import React, { useState } from "react";
import FooterPagesBackground from "../assets/FooterPagesBackground.webp";
import liggandebakrund from "../assets/liggandebakgrund.svg";
import ToHomeBtn from "../components/Shared/ToHomepageBtn";
import "./css/ContactAndCustomerServicePage.css";
import emailjs from "emailjs-com"
import FooterInsideSmallerPages from "./FooterInsideSmallerPages";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function ContactForm() {
  const [amne, setAmne] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  //right now we are using free plan for emailJs
  //but later when the domain is set up, and the email has the domain in it,
  //sendEmail function will use brevo instead.
  //Brevo works more than like emailJs does, it sends autoreply to the kunden,
  //it will redirect the email to the Product Owner (after the @providersverige.com set)
  //and it can also store the emails that subscribe to newsletter as well as setting up the periodical newsletter sendings too
  //right now, since we dont have the domain yet, we use emailJs.

  const validateInput = () => {
    if (!amne || !email || !message) {
      toast.info("Vänligen fylla i alla fälten", {
        position: "top-right", autoClose: 3000 })
      return false
    }
  }

  //sending the email to emailJs
  const sendEmail = (e) => {
    e.preventDefault();
    if (!validateInput()) {
      return
    }
    
    emailjs.send(
      "service_iu7yjyd",
      "template_m26vwnw",
      { amne: amne, email: email, message: message },
      "v8ue4p8fqD1-cZ75K"
    ).then((response) => { //directly generating autoreply for bekräftalse
      toast.success("Vi har tagit ditt meddelande", {
        position: "top-right", autoClose: 3000 })
      emailjs.send(
        "service_iu7yjyd",
        "template_l76bk7m",
        {email: email},
        "v8ue4p8fqD1-cZ75K"
      )
      setAmne("")
      setEmail("")
      setMessage("")
    }, (error) => {
      console.log("Error: " + error)
    })
  }

  return (
    <div className="kundtjanst-contact-form-container">
      <ToastContainer />
      <div
        className="kundtjanst-background-image"
        style={{ backgroundImage: `url(${liggandebakrund})` }}
      ></div>
      <div className="kundtjanst-content-container">
        <ToHomeBtn />
        <div className="kundtjanst-contact-sections">
          <div className="kundtjanst-contact-info">
            <h2>Kontakt</h2>
            <div className="kundtjanst-below-tittle">
              <h3>Provider Sverige</h3>
              <br />
              <p>Box 1</p>
              <p>111 11 Malmö</p>
              <p>Sverige</p>
              <br />
              <br />
              <p>info@providersverige.com</p>
              <p>070 - 000 00 00</p>
              <br />
              <br />
              <div className="kundtjanst-social-icons">
                <a
                  href="https://www.facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg"
                    alt="Facebook"
                  />
                </a>
                <a
                  href="https://www.instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                    alt="Instagram"
                  />
                </a>
                <a
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png"
                    alt="LinkedIn"
                  />
                </a>
                <a
                  href="https://blueskyweb.xyz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Bluesky_Logo.svg/600px-Bluesky_Logo.svg.png"
                    alt="BlueSky"
                  />
                </a>
                <a
                  href="https://threads.net"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Threads_%28app%29.svg/512px-Threads_%28app%29.svg.png"
                    alt="Threads"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="kundtjanst-contact-form">
            <h2>Kundservice</h2>
            <form onSubmit={sendEmail}>
              <input
                type="text"
                placeholder="Ämne"
                value={amne}
                onChange={(e) => setAmne(e.target.value)}
              />
              <input
                type="email"
                placeholder="Din e-postadress"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <textarea
                placeholder="Meddelande"
                rows="6"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <button type="submit" className="kundtjanst-send-button">
                Skicka
              </button>
            </form>
          </div>
        </div>
      </div>
      <FooterInsideSmallerPages />
    </div>
  );
}

export default ContactForm;


